import axios from "axios"

export const http = axios.create({
	baseURL: "https://steward-anizlarfaa-uc.a.run.app",
	// baseURL: "http://localhost:1115",
})
